export const APP_SETTINGS = {
  MIN_PASSWORD_LENGTH: 8,
  MAX_PHONE_NUMBER_LENGTH: 15,
  MIN_BUSINESS_NAME_LENGTH: 3,
}
